import Noty from 'Noty'
import 'noty/lib/noty.css'

Noty.overrideDefaults({
  layout: 'bottomLeft',
  theme: 'bootstrap-v4',
  timeout: 2000
})

let success = function (text, options = {}) {
  new Noty({
    text: text,
    type: 'success',
    timeout: options.timeout || 2000
  }).show()
}

let error = function (text) {
  new Noty({
    text: text,
    type: 'error'
  }).show()
}

let info = function (text, options = {}) {
  const buttons = options.buttons || []
  options.callbacks = options.callbacks || {}
  var n = new Noty({
    type: 'info',
    buttons,
    progressBar: options.progressBar || options.timeout > 0,
    timeout: options.timeout || false,
    ...options,
    callbacks: {
      ...options.callbacks,
      onClick: options.closable ? null : options.callbacks.onClick,
      onTemplate: !options.closable ? null : function() {
        // var text = document.createElement('div')
        // text.classList = ['noty_body']
        // text.innerText = this.options.text
        // // if (options.closable) {
        // //   buttons.push(Noty.button('Fermer', 'btn', function () {
        // //     n.close()
        // //   }, {id: 'closeButton', 'data-status': 'ok'}))
        // // }
        // // text +=
        this.barDom.innerHTML = '<div class="my-custom-template noty_body"><i class="fa fa-times close" style="padding-left: 10px; margin-top: 4px; }"></i>' + this.options.text + '<div>'
        this.barDom.addEventListener('click', (event) => {
          if (event.target.classList.contains('close')) {
            n.close()
          } else {
            options.callbacks.onClick && options.callbacks.onClick()
          }
        }, false)
        // Important: .noty_body class is required for setText API method.
      }
    },
    text: text
  }).show()
  return n
}

Noty.success = success
Noty.error = error
Noty.info = info

export default Noty
export {success, error, info}



// WEBPACK FOOTER //
// ./src/components/shared/Notify.js